/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/money_left'
export default icon
